import * as glMatrix from 'gl-matrix';

export class Camera {
    _zoomMatrix: glMatrix.mat4;
    _zoomInverseMatrix: glMatrix.mat4;
    _panMatrix: glMatrix.mat4;
    _panInverseMatrix: glMatrix.mat4;
    _action: string;
    _width: number;
    _height: number;
    _started: boolean;
    _startEvent: any;
    _ndc: any;
    _init() {
        var self = this;
        self._zoomMatrix = glMatrix.mat4.create();
        self._zoomInverseMatrix = glMatrix.mat4.create();
        self._panMatrix = glMatrix.mat4.create();
        self._panInverseMatrix = glMatrix.mat4.create();
        self._action = 'PAN';
        self._width = 0;
        self._height = 0;
        self._started = false;
    }

    constructor(ndc: any) {
        this._ndc = ndc;
        this._init();
    }

    reset() {
        this._init();
    }

    get zoom() {
        return this._zoomMatrix;
    }

    get zoomInverse() {
        return this._zoomInverseMatrix;
    }

    get pan() {
        return this._panMatrix;
    }

    get panInverse() {
        return this._panInverseMatrix;
    }

    start(action: string, width: number, height: number, event: any) {
        var self = this;
        self._action = action;
        self._width = width;
        self._height = height;
        self._startEvent = event;
        self._started = true;
    }

    move(event: any, invert?: any) {
        var self = this;
        if (self._action === 'PAN') {
            self._pan(event, invert);
        }
    }

    wheel(event: any) {
        this._zoom(event);
    }

    end() {
        this._started = false;
    }

    started() {
        return this._started;
    }

    _pan(event: { offsetX: number; offsetY: number; }, invert: any) {
        var self = this;
        var dx = event.offsetX - self._startEvent.offsetX;
        var dy = (invert ? 1 : -1) * (event.offsetY - self._startEvent.offsetY);
        dx /= (self._width / 2);
        dy /= (self._height / 2);
        var translate = glMatrix.vec2.fromValues(dx, dy);
        glMatrix.vec2.transformMat4(translate, translate, self._zoomInverseMatrix);
        glMatrix.mat4.translate(self._panMatrix, self._panMatrix, [translate[0], translate[1], 0]);
        glMatrix.mat4.invert(self._panInverseMatrix, self._panMatrix);
        self._startEvent = event;
    }

    _zoom(event: { deltaY: number; }) {
        var self = this;
        var dy = -event.deltaY / self._height;
        glMatrix.mat4.scale(self._zoomMatrix, self._zoomMatrix, [1 + dy * 0.2, 1 + dy * 0.2, 1]);
        glMatrix.mat4.invert(self._zoomInverseMatrix, self._zoomMatrix);
    }

}
